import React from "react";

const StandardsContext = React.createContext();

export { StandardsContext };
